import * as React from 'react';

import { IPaymentDetails } from 'src/model/credit.model';

import './CreditsPaymentDetailsRow.scss';
import LocaleFormating from 'src/translation/localeFormating';
import { currencyFormatter } from 'src/utils/currencyFormatter';

interface ICreditsPaymentDetailsRowProps {
  payment: IPaymentDetails;
  customerCode: string;
}

class CreditsPaymentDetailsRow extends React.Component<
  ICreditsPaymentDetailsRowProps,
  any
> {
  public render() {
    return (
      <div className="rp-credits-payment-details-row">
        <div className="rp-credits-p-details-item col-2">
          <span>{this.props.payment.invoice.invoiceNumber}</span>
        </div>
        <div className="rp-credits-p-details-item col-2">
          <span>
            {LocaleFormating.formatDate(
              this.props.payment.invoice.invoiceDate,
              'short'
            )}
          </span>
        </div>
        <div className="rp-credits-p-details-item col-2">
          <span>{currencyFormatter(this.props.payment.totalAmount)}</span>
        </div>
        <div className="rp-credits-p-details-item col-2">
          <span>{currencyFormatter(this.props.payment.paymentAmount)}</span>
        </div>
        <div className="rp-credits-p-details-item col-4 rp-credits-p-details-italic">
          <span>{this.props.payment.reasonRemainingBalance}</span>
        </div>
      </div>
    );
  }
}

export default CreditsPaymentDetailsRow;
